import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { User } from '@ha/api/v2/types/User';
import { useIntl } from 'ha/i18n';
import { Grid, units, Typography } from '@hbf/dsl';
import { UserAvatar } from 'ha/components/UserAvatar';
import { ExcellentAdvertiserBadge } from 'ha/components/Redesign/ExcellentAdvertiserBadge';

import { UserCardLink } from './UserCardLink';
import { UserReviewsRating } from './UserReviewsRating';

const useStyles = makeStyles()(theme => ({
  avatar: {
    marginRight: units.rem(0.563),
  },
  badge: {
    marginTop: units.rem(0.1),
    marginLeft: units.rem(0.5),
  },
  container: {
    backgroundColor: theme.palette.white.light,
    padding: units.yx(1, 1.5),
    [theme.breakpoints.up('md')]: {
      backgroundColor: theme.palette.grey[50],
      borderRadius: units.rem(0.25),
    },
    [theme.breakpoints.up('lg')]: {
      minWidth: units.rem(24),
    },
  },
  title: {
    color: theme.palette.grey[600],
  },
}));

interface Props {
  user: User;
}

const UserCardInfo: React.FC<Props> = ({ user }) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      className={classes.container}
    >
      <Grid item className={classes.avatar}>
        <UserCardLink
          user={user}
          data-test-locator="User Card Avatar - Redesign"
        >
          <UserAvatar size="xxs" avatarURL={user.avatarURL} />
        </UserCardLink>
      </Grid>
      <Grid item>
        <Typography.Caption className={classes.title}>
          {T('Advertised by')}
        </Typography.Caption>
        <Grid container direction="row">
          <Grid item>
            <UserCardLink user={user} data-test-locator="User Card Name">
              <Typography.Paragraph color="primary">
                {user.firstName}
              </Typography.Paragraph>
            </UserCardLink>
          </Grid>
          {user.isTrusted && (
            <Grid item className={classes.badge}>
              <ExcellentAdvertiserBadge />
            </Grid>
          )}
        </Grid>
      </Grid>
      <UserReviewsRating />
    </Grid>
  );
};

export { UserCardInfo };
